import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap';
import Grid from '@mui/material/Grid2';
import TaskDisccussCase from '../CaseDetails/TaskDisccussCase';

function OnboardingOnlyCaseDiscussTab({showCase, casediscuss, caseStatus}) {

    const [activeTabCase, setActiveTabCase] = useState("casediscuss");
  return (
    <Grid size={{sm:12}} container className="tab_controllers control_splits" alignContent="flex-start">
        <Tabs
            activeKey={activeTabCase}
            onSelect={(key) => setActiveTabCase(key)}
            defaultActiveKey="casediscuss"
            id="uncontrolled-tab-example" className="mt-4 drafttabs_tabs"
        >
            {showCase && 
            <Tab eventKey="casediscuss" title="Case Discussion">
                {activeTabCase === "casediscuss" && <TaskDisccussCase casediscuss={casediscuss} caseStatus={caseStatus}/>}
            </Tab>
            }
        </Tabs>
    </Grid>
  )
}

export default OnboardingOnlyCaseDiscussTab
